<template>
  <div ref="npsindecx"></div>
</template>

<script>
export default {
  name: "npsIndecx",
  mounted() {
    //Exibir o NPS para usuários que a data do ultimo acesso for > que 45 dias e que tenham entrado pelo menos 2 vezes no Portal
    const lastAccessRule = ((this.necessaryDates.lastAccessInDays > 45) && (this.necessaryDates.accessQtd > 2));
    //Exibir o NPS para usuários que a data do ultimo acesso for > que 45 dias e que tenham entrado pelo menos 2 vezes no Portal
    const createdAtRule = ((this.necessaryDates.createdAtInDays > 45) || this.necessaryDates.accessQtd > 3);

    if (process.env.NPS_ACTIVE && (lastAccessRule || createdAtRule)) {
      const c = {
        key: "5e5d0e5faef4de001e58ffa7",
        action: "63e2a598ad175e0014587e5c",
        name: this.userLogged.usu_nome,
        email: this.userLogged.usu_email,
        indicators: {
          empresa: localStorage.getItem('group'),
          phone: this.userLogged.usu_celular
        }
      };

      let e;
      if (document.getElementById("script-indecx")) {
        return;
      }
      e = document.createElement("script");
      e.id = "script-indecx";
      e.src = "https://indecx-widget.s3.amazonaws.com/widget.js";
      e.type = "text/javascript";
      e.async = true;
      e.onload = e.onreadystatechange = function () {
        const h = this.readyState;
        if (h && h != "complete" && h != "loaded") {
          return;
        }
        try {
          IndeCX(c);
        } catch (i) {
        }
      };
      this.$refs.npsindecx.appendChild(e);
    }
  },
  computed: {
    necessaryDates() {
      let daysSinceLastAccess = this.howManyDaysSince(new Date(this.userLogged.usu_dt_ultimo_acesso));
      let daysSinceCreation = this.howManyDaysSince(new Date(this.userLogged.usu_dt_criacao));

      return {
        "accessQtd": parseInt(this.userLogged.usu_qtd_acesso),
        "lastAccessInDays": daysSinceLastAccess,
        "createdAtInDays": daysSinceCreation
      };
    },
    userLogged() {
      return JSON.parse(localStorage.getItem("userLogged"));
    },
  },
  methods: {
    howManyDaysSince($dateToCompare) {
      let dateNow = new Date();
      let diffDatesInMilliseconds = (dateNow - $dateToCompare);
      return Math.floor((diffDatesInMilliseconds / (1000 * 60 * 60 * 24)));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/common/components/npsIndecx.vue